module.exports = __webpack_public_path__ + "media/images/favicon-2e4c6314a7c2c3f0bb12a4ebc02ac8cd.ico";